import classNames from 'classnames';
import { Dropdown, Menu, MenuItem, Popover, Radio } from 'components-antd';
import { ICON_VARIANT_TYPE, Icons } from 'pages/FormProcess/Icons';

import styles from './styles.module.scss';
import { SmartFormIcons } from 'components';
import { Check } from 'components/Icons';
import { useState } from 'react';

export const SignFontsPopover = ({ fontOptions, font, name, onSelectFont }) => {
  const [open, setOpen] = useState(false);

  const onChangeFont = ({ target }) => {
    if (target.value !== font) {
      onSelectFont(target.value);
      setOpen(false);
    }
  };

  const menu = (
    <Radio.Group className={styles.optionsItems}>
      <Menu>
        <div className={styles.signatureHeader}>Choose Signature Font</div>
        <div className={styles.fontMenuItems}>
          {fontOptions.map((fontStyle, idx) => (
            <MenuItem key={idx}>
              <Radio value={fontStyle} key={idx} onChange={onChangeFont}>
                <div className={styles.fontOptionValue} style={{ fontFamily: fontStyle }}>
                  {name || 'John  Doe'}
                </div>
                {font === fontStyle && <Check className={styles.checkIcon} />}
              </Radio>
            </MenuItem>
          ))}
        </div>
      </Menu>
    </Radio.Group>
  );

  return (
    <div className={classNames(styles.fontDropdownWrapper)}>
      <Dropdown
        overlay={menu}
        placement="bottomRight"
        trigger={['click']}
        onOpenChange={setOpen}
        overlayClassName={styles.fontPopover}
      >
        <div className={classNames(styles.signFontWrapper, { [styles.openedFontWrapper]: open })}>
          <SmartFormIcons variant={'pencil'} />
          <div className={styles.title}>Style</div>
        </div>
      </Dropdown>
    </div>
  );
};
